export default {
  'delivery-bookings.id': 'ID',
  'delivery-bookings.title': 'Booking List',
  'delivery-bookings.delivery_booking_no': 'Booking No.',
  'delivery-bookings.booking_type': 'Type',
  'delivery-bookings.pickup_address': 'Pickup Address',
  'delivery-bookings.delivery_address': 'Delivery Address',
  'delivery-bookings.pickup_delivery_address': 'Pickup / Delivery Address',
  'delivery-bookings.company_name': 'Company Name',
  'delivery-bookings.country_code': 'Country Code',
  'delivery-bookings.city': 'City',
  'delivery-bookings.state': 'State',
  'delivery-bookings.contact_person_name': 'Contact Person',
  'delivery-bookings.contact_phone': 'Contact Phone',
  'delivery-bookings.delivery_contact_person': 'Delivery Contact Person',
  'delivery-bookings.delivery_contact_phone': 'Delivery Contact Phone',
  'delivery-bookings.postal_code': 'Postal Code',
  'delivery-bookings.request_items': 'Request Booking Packages',
  'delivery-bookings.request_collection_date': 'Delivery / Collection Date',
  'delivery-bookings.request_collection_time': 'Ready Time',
  'delivery-bookings.pickup_note': 'Pickup Note',
  'delivery-bookings.show_request_items': 'Show Request Booking Packages',
  'delivery-bookings.search_items': 'Search By Tracking No. Or Reference No.',
  'delivery-bookings.shipment_scan_date': 'Scanned Date',
  'delivery-bookings.scanned_packages': 'Scanned Packages',
  'delivery-bookings.action': 'Action',
  'delivery-bookings.status': 'Status',
  'delivery-bookings.message.booking_type': 'Please Choose Pickup Or Delivery',
  'delivery-bookings.message.address': 'Please enter pickup address',
  'delivery-bookings.message.contact_phone': 'Please enter contact phone',
  'delivery-bookings.message.contact_person_name': 'Please enter contact',
  'delivery-bookings.message.batch_id': 'Please select available batch id',
  'delivery-bookings.message.request_collection_date': 'Please select collection date',
  'delivery-bookings.message.request_collection_time': 'Please select available collection time',
  'delivery-bookings.batch.title': 'Create Booking Appointment',
  'delivery-bookings.type.pickup': 'Request Pickup',
  'delivery-bookings.type.delivery': 'Delivery to Warehouse',
  'delivery-bookings.update': 'Update Booking Appointment',
  'delivery-bookings.update.success': 'Pickup schedule has been succesfully updated ',
  'delivery-bookings.create.fail': 'Fail to create pickup schedule',
  'delivery-bookings.create.success': 'Pickup schedule has been succesfully created',
  'delivery-bookings.update.fail': 'Fail to update pickup schedule',
  'delivery-bookings.form_item.title': 'Booking Packages',
  'delivery-bookings.details.reference_no': 'Reference No.',
  'delivery-bookings.details.shipment_number': 'Tracking No.',
  'delivery-bookings.received-confirm': 'Are you sure you want to received this {document_no}',
  'delivery-bookings.cancel-confirm': 'Are you sure to cancel this {document_no} booking order?',
  'delivery-bookings.upload_items': 'Upload Packages',
  'delivery-bookings.export_to_excel': 'Export your data to excel',
  'delivery-bookings.download': 'Download',
  'delivery-bookings.show_request_item_title': '{document_no} Booking Packages',
  'delivery-bookings.details.status': 'Status',
  'delivery-bookings.prepared.success': 'The Booking has been succesfully prepared.',
};
